import { render, staticRenderFns } from "./limit-dialog.vue?vue&type=template&id=7820e660&"
import script from "./limit-dialog.vue?vue&type=script&lang=js&"
export * from "./limit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports